import apiDtMood from './dtMoodApiHandler'
import { getDtMoodSession } from './dtmood-session.service'

const getCollaborators = () => {
  const dtMoodSession = getDtMoodSession()
  const clientId = dtMoodSession ? dtMoodSession.clientId : ''

  return new Promise((resolve, reject) => {
    apiDtMood
      .get(`/api/users/${clientId}/collaborator-list/`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export { getCollaborators }
